export default __webpack_public_path__ + "static/media/me.93563282.png";